<template>
	<div class="ww-userinfo-body">
		<div class="ww-userinfo-head">
			<a :class="{active: currentTpl == 'source'}" href="javascript:;" style="width: 33.3%">
				<span class="text-box" @click="currentTpl = 'source'">客户来源</span>
			</a>
			<a :class="{active: currentTpl == 'workOrder'}" href="javascript:;" style="width: 33.3%">
				<span class="text-box" :class="{redsign: showSign}" @click="clickWorkOrder">工单</span>
			</a>
			<a :class="{active: currentTpl == 'userRemark'}" href="javascript:;" style="width: 33.3%">
				<span class="text-box" @click="currentTpl = 'userRemark'">客户备注</span>
			</a>
		</div>
		<div class="ww-userinfo-body">
			<wxSource v-show="currentTpl == 'source'" @initSuccess="initSourceSuccess"></wxSource>
			<qxWorkOrder ref="qxWorkOrder" v-if="extInfos.find(o => o.name == 'qxjike_user_id') && currentTpl == 'workOrder'" :extInfos="extInfos" />
			<huajiaWorkOrder v-else-if="(currentShop.id == 3753 || currentShop.id == 1611 || currentShop.id == 6765) && currentTpl == 'workOrder'"></huajiaWorkOrder>
			<wxWorkOrder v-else-if="currentTpl == 'workOrder'"></wxWorkOrder>
			<userRemark v-if="currentTpl == 'userRemark'"></userRemark>
		</div>
	</div>
</template>

<script>
import wxSource from './wxSource.vue'
import wxWorkOrder from './wxWorkOrder.vue'
import huajiaWorkOrder from './huajiaWorkOrder.vue'
import qxWorkOrder from './qxWorkOrder.vue'
import userRemark from './userRemark.vue'
import Logan from 'logan-web';
export default {
	name: 'wxUserInfoTpl',
	data () {
		return {
			currentTpl: 'source', // source(来源)、workOrder(工单)
			extInfos: [],
			qxPhone: null,
			showSign: false
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		}
	},
	components: {
		'wxSource': wxSource,
		'wxWorkOrder': wxWorkOrder,
		'huajiaWorkOrder': huajiaWorkOrder,
		'qxWorkOrder': qxWorkOrder,
		'userRemark': userRemark
	},
	watch: {
		currentConversation: {
			deep: true,
			handler (now, old) {
				if (now.id == old.id || !now.id) return;
				this.currentTpl = 'source';
				this.showSign = false
			}
		}
	},
	created() {
		if (!window.originalSetItem) {
			window.originalSetItem = localStorage.setItem;
			localStorage.setItem = function(key, value) {
				var setItemEvent = new Event('setItemEvent');
				setItemEvent.key = key;
				setItemEvent.newValue = value;
				window.dispatchEvent(setItemEvent);
				originalSetItem.apply(this, arguments);
			}
		}
		window.addEventListener('setItemEvent', this.setItemEvent)
	},
	beforeDestroy () {
		window.removeEventListener('setItemEvent', this.setItemEvent)
	},
	methods: {
		setItemEvent(e) {
			if (e.key !== 'qxjike') return
			var obj = JSON.parse(e.newValue)
			if (this.qxPhone && obj[this.qxPhone]) {
				this.showSign = true
				var audio = document.getElementById('adobibi')
				if (!window.userClick) {
					console.log('用户从未点击过页面，工单语音通知失败')
					Logan.log('用户从未点击过页面，工单语音通知失败', 1);
				}

				audio && audio.play()
				this.$message.info('工单信息有更新')

				this.$refs.qxWorkOrder && this.$refs.qxWorkOrder.getTicketList(this.$refs.qxWorkOrder.userPhone)
			}
		},

		clickWorkOrder() {
			this.currentTpl = 'workOrder';
			this.showSign = false;
			var obj = JSON.parse(localStorage.getItem('qxjike') || '{}');
			if (this.qxPhone && obj[this.qxPhone]) {
				delete obj[this.qxPhone]
				localStorage.setItem('qxjike', JSON.stringify(obj))
			}
		},

		// 初始化来源回调
		initSourceSuccess(res) {
			this.extInfos = res
			this.qxPhone = null
			this.showSign = false
			var temp = res.find(o => o.name === 'qxjike_user_id')
			temp && this.getUserPhone(temp.value).then(phone => {
				this.qxPhone = phone
				this.setItemEvent({
					key: 'qxjike',
					newValue: localStorage.getItem('qxjike') || '{}'
				})
			})
		},

		// 获取用户手机号
		getUserPhone(userId) {
			return new Promise((resolve, reject) => {
				let data = { userId }
				this.$axios.post(API_ROOT.url + '/QxJiKeApi.queryUserInfo', data).then(res => {
					if (res.status) {
						let o = res.data || {}
						resolve(o['客户电话'])
					} else {
						this.$message.error('获取用户手机号失败，失败原因：' + (result.msg || result.message));
						reject()
					}
				}, err => {
					this.$message.error('获取用户手机号失败，错误码(' + err + ')');
					reject()
				})
			})
		}
	}
}
</script>

<style scoped lang="less">
.redsign:after {
	position: relative;
	top: -2px;
	left: 5px;
	display: inline-block;
	width: 6px;
	height: 6px;
	background: #f00;
	border-radius: 50%;
	content: ''
}
</style>


// WEBPACK FOOTER //
// src/pages/aside/wxUserInfoTpl.vue